import { createSelector } from "reselect";

import { routeIdSelector as customerIdSelector } from "../customer/selectors";
import { CustomerState } from "../customer";

import { CustomerUser, AppState } from "./model";

export const routeIdSelector = (state: AppState) => {
    return state.router.params?.customerUserId;
};

export const routeCustomerIdSelector = (state: AppState) => {
    return state.router.params?.customerId;
};

export type SelectorState = AppState & CustomerState;

export const customerUsersSelector = (state: SelectorState) =>  {
    const customerId = customerIdSelector(state);
    let customerUsers = state.customerUsers;

    customerUsers = customerUsers.filter(p => p.customerId === customerId);
    return customerUsers;
};

export const customerUserSelector = createSelector(
    customerUsersSelector,
    routeIdSelector,
    (customerUsers: CustomerUser[], id: any) => {
        return customerUsers.filter(c => c.id === id)[0] || {} as CustomerUser;
    }
);

export const basePathSelector = (state: AppState) =>
    state.router.pathname.substring(0, state.router.pathname.indexOf("customerUsers") + "customerUsers".length);
